import '../styles/homepage.scss';
import Branche from './sections/Branche';
import Community from './sections/Community';
import Contact from './sections/Contact';

const HERO_SRC = `${process.env.PUBLIC_URL || ''}/hero-home.webp`;
const HERO_SRC_MD = `${process.env.PUBLIC_URL || ''}/hero-home-800.webp`;
const HERO_SRC_SM = `${process.env.PUBLIC_URL || ''}/hero-home-640.webp`;

const Homepage = () => {
  return <>
    <div className="h-screen bg-home">
      <img
        className="bg-home__img"
        src={HERO_SRC}
        srcSet={`${HERO_SRC_SM} 640w, ${HERO_SRC_MD} 800w, ${HERO_SRC} 1600w`}
        sizes="100vw"
        alt="Gruppo Scout Acireale 6"
        width={1600}
        height={720}
        decoding="async"
        fetchPriority="high"
        loading="eager"
      />
      <div className="bg-home__overlay" aria-hidden="true" />
    </div>
    <Community />
    <section className='flex justify-center items-center full bg-future py-10'>
      <div>
        <p className='text-white text-3xl text-center font-poppins px-10'>"Vogliamo che gli uomini della prossima generazione siano di più ampie vedute e che si considerino reciprocamente come fratelli, in ogni parte del mondo."</p>
      </div>
    </section>
    <Branche />
    <Contact />
    {/*<section className='bg-empty'>
      <div className='flex flex-col items-center px-10 py-20 gap-10'>
        <p className='text-white text-2xl'>Se ti stiamo simpatici puoi donare al <b>5x1000</b> al nostro gruppo!</p>
        <p className='text-white text-4xl'><b>C.F. 90030200878</b></p>
      </div>
    </section>*/}
  </>
}

export default Homepage;
